export const COMPANY_NAME = "The McDowell Effect LLC";
export const COMPANY_SHORT = "The McDowell Effect";
export const COMPANY_INITIALS = "ME";
export const COMPANY_ADDRESS_FULL = "112 Stanley Street, Petaluma, CA 94952";
export const COMPANY_LOCATION = "Petaluma, CA";
export const COMPANY_REGION = "Petaluma, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=112%20Stanley%20Street%2C%20Petaluma%2C%20CA%2094952";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Limited liability company" },
  { "label": "Established", "value": "May 2025" },
  { "label": "Location", "value": "Petaluma, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "The McDowell Effect LLC" },
  { "label": "Location", "value": "Petaluma, CA" },
  { "label": "Principal office", "value": "112 Stanley Street, Petaluma, CA 94952" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Lawful activity", "body": "Organized to engage in lawful business activity under California law." },
  { "icon": "✦", "title": "Local presence", "body": "A public directory profile rooted in Petaluma, California." },
  { "icon": "✿", "title": "Flexible purpose", "body": "The public filing states a broad purpose for permitted business activity." },
  { "icon": "❍", "title": "Public information", "body": "This page shares only directory-safe details from the public filing." },
];
